import Vue from 'vue'
import Router from 'vue-router'

import Index from '../view/Index.vue'//首页

import JobIndex from '../view/Job/Index.vue'//新房
import JobDetail from '../view/Job/Detail.vue'//新房--详情
import SaleDetail from '../view/Job/SaleDetail.vue'//新房--详情--楼盘详情
import BuildImg from '../view/Job/BuildImg.vue'//新房--详情--楼盘相册
import BuildImgType from '../view/Job/BuildImgType.vue'//新房--详情--楼盘相册--类型
import BuildImgDetail from '../view/Job/BuildImgDetail.vue'//新房--详情--楼盘相册详情
import HouseType from '../view/Job/HouseType.vue'//新房--详情--户型介绍
import HouseTypeDetail from '../view/Job/HouseTypeDetail.vue'//新房--详情--户型介绍详情
import Evaluate from '../view/Job/Evaluate.vue'//新房--详情--用户点评
import Around from '../view/Job/Around.vue'//新房--详情--周边配置地图
import Dynamics from '../view/Job/Dynamics.vue'//新房--详情--周边配置地图
import MessageIndex from '../view/Message/Index.vue'//楼盘资讯
import MessageDetail from '../view/Message/Detail.vue'//楼盘资讯--详情
import Activity from '../view/Activity/index.vue' //特惠活动

import HOCTIME from '../view/Html/HOCTIME.vue'
import HoctimeDetail from '../view/Hoctime/Detail.vue'
import FOLKTALE from '../view/Html/FOLKTALE.vue'
import FolktaleDetail from '../view/Folktale/Detail.vue'
import NewsDetail from '../view/News/Detail.vue'

import LUARA from '../view/Html/LUARA.vue'
import MAESOUL from '../view/Html/MAESOUL.vue'
import BRAND_UPGRADING from '../view/Html/BRAND_UPGRADING.vue'
import NEW_ARRIVIAL from '../view/Html/NEW_ARRIVIAL.vue'
import Company from '../view/plus/company.vue'
import News from '../view/plus/news.vue'
import About from '../view/plus/about.vue'
import CONSULTANT from '../view/plus/CONSULTANT.vue'
import CONTACT from '../view/plus/CONTACT.vue'
import APP from '../view/plus/APP.vue'
import TA from '../view/plus/TA.vue'
import Address from '../view/plus/address.vue'
import COMING_SOON from '../view/Html/COMING_SOON.vue'
import AboutHocTime from '../view/plus/AHOCTIME.vue'

Vue.use(Router)
export default new Router({
  routes: [
    {path: '/', name: 'Index', component: Index},

    {path: '/jobIndex', name: 'jobIndex', component: JobIndex},
    {path: '/jobDetail', name: 'JobDetail', component: JobDetail},
    {path: '/saleDetail', name: 'saleDetail', component: SaleDetail},
    {path: '/buildImg', name: 'BuildImg', component: BuildImg},
    {path: '/buildImgType', name: 'BuildImgType', component: BuildImgType},
    {path: '/buildImgDetail', name: 'BuildImgDetail', component: BuildImgDetail},
    {path: '/houseType', name: 'HouseType', component: HouseType},
    {path: '/houseTypeDetail', name: 'HouseTypeDetail', component: HouseTypeDetail},
    {path: '/evaluate', name: 'Evaluate', component: Evaluate},
    {path: '/around', name: 'Around', component: Around},
    {path: '/dynamics', name: 'Dynamics', component: Dynamics},
    {path: '/messageIndex', name: 'MessageIndex', component: MessageIndex},
    {path: '/messageDetail', name: 'MessageDetail', component: MessageDetail},
    {path: '/activity', name: 'Activity', component: Activity},
    {path: '/HOCTIME', name: 'HOCTIME', component: HOCTIME},
    {path: '/HoctimeDetail', name: 'HoctimeDetail', component: HoctimeDetail},

    {path: '/FOLKTALE', name: 'FOLKTALE', component: FOLKTALE},
    {path: '/FolktaleDetail', name: 'FolktaleDetail', component: FolktaleDetail},
    {path: '/NewsDetail', name: 'NewsDetail', component: NewsDetail},
    {path: '/AboutHocTime', name: 'AboutHocTime', component: AboutHocTime},  

    {path: '/LUARA', name: 'LUARA', component: LUARA},
    {path: '/MAESOUL', name: 'MAESOUL', component: MAESOUL},
    {path: '/BRAND_UPGRADING', name: 'BRAND_UPGRADING', component: BRAND_UPGRADING},
    {path: '/NEW_ARRIVIAL', name: 'NEW_ARRIVIAL', component: NEW_ARRIVIAL},
    {path: '/Company', name: 'Company', component: Company},
    {path: '/News', name: 'News', component: News},
    {path: '/About', name: 'About', component: About},
    {path: '/CONSULTANT', name: 'CONSULTANT', component: CONSULTANT},
    {path: '/CONTACT', name: 'CONTACT', component: CONTACT},
    {path: '/APP', name: 'APP', component: APP},
    {path: '/TA', name: 'TA', component: TA},
    {path: '/Address', name: 'Address', component: Address},
    {path: '/COMING_SOON', name: 'COMING_SOON', component: COMING_SOON},

  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js